<template>
  <el-card shadow="never" class="notes">
    <template slot="header">
      <div class="control-bar">
        <div>
          Type:
          <el-select v-model="noteType" size="medium">
            <el-option value="all" label="All"></el-option>
            <el-option value="Profile Changes" label="Profile Changes"></el-option>
            <el-option value="General" label="General"></el-option>
            <el-option value="Auction" label="Auction"></el-option>
          </el-select>
        </div>
        <div>
          Facility:
          <el-select v-model="facilityType" size="medium">
            <el-option value="all" label="All"></el-option>
            <el-option value="overall" label="Overall"></el-option>
            <el-option v-for="facility in customer.locations" :key="facility" :value="facility" :label="facilityLabelMap[facility]"></el-option>
          </el-select>
        </div>
        <div>
          <el-button @click="switchDrawer" type="primary" size="medium">
            Add Note
          </el-button>
          <el-button
            size="medium"
            @click="() => bannerNoteDialogVisible = true"
          >
            Edit Banner note
          </el-button>
        </div>
      </div>
    </template>
    <!-- List the notes -->
    <ElTable
      :default-sort = "{prop: 'createdAt', order: 'descending'}"
      :data="filteredNotes"
      style="width: 100%"
      v-loading="loading"
      height="500px"
      empty-text="No Notes"
    >
      <ElTableColumn
        label="Description"
        :width="650"
        >
        <template slot-scope="scope">
          <div v-if="scope.row.type === 'Profile Changes'">
            {{noteLabel(scope.row.description)}}
          </div>
          <div v-else-if="scope.row.type !== 'Email'">
            <Description :content="scope.row.description" />
          </div>
        </template>
      </ElTableColumn>
      <ElTableColumn
        property="createdAt"
        label="Created At"
        :width="120"
        :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
        sortable
      >
      </ElTableColumn>
      <ElTableColumn
        v-if="showType"
        property="type"
        label="Type"
        :width="120"
      >
      </ElTableColumn>
      <ElTableColumn
        label="Facility"
        :width="120"
        sortable
      >
        <template slot-scope="scope">
          <div v-if="scope.row.facility">{{facilityLabelMap[scope.row.facility]}}</div>
          <div v-else>Overall</div>
        </template>
      </ElTableColumn>
      <el-table-column
        label="Actions"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="View Changes" placement="top-start">
            <el-button
              v-show="scope.row.type === 'Profile Changes'"
              icon="el-icon-view"
              type="text"
              @click="() => viewNote(scope)"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="View Attachment" placement="top-start">
            <el-button
              v-show="(scope.row.attachment && scope.row.attachment.url)"
              icon="el-icon-view"
              type="text"
              @click="() => viewNote(scope)"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Edit" placement="top-start">
            <el-button
              icon="el-icon-edit"
              type="text"
              v-if="scope.row.type === 'Auction' || scope.row.type === 'General'"
              @click="() => openEditNote(scope)"
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Delete" placement="top-start">
            <el-button
              icon="el-icon-delete"
              type="text"
              v-if="scope.row.type === 'Auction' || scope.row.type === 'General'"
              @click="() => deleteNote(scope)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </ElTable>

    <!-- Drawer -->
    <el-dialog
      :visible.sync="drawer"
      width="40%"
      append-to-body
    >
      <el-form :model="note" ref="note" label-width="150px">
        <el-form-item
          v-if="showType"
          label="Type"
          prop="type"
        >
          <el-select
            v-model="note.type"
            placeholder="Type"
          >
            <el-option
            label="Auction"
            value="Auction"
            >
            </el-option>
            <el-option
            label="General"
            value="General"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="showType"
          label="Facility"
          prop="facility"
        >
          <el-select
            v-model="note.facility"
            placeholder="Facility"
            @change="handleFacilityChange"
          >
            <el-option
              label="Overall"
              value="overall"
            >
            </el-option>
            <el-option v-for="facility in customer.locations" :key="facility" :value="facility" :label="facilityLabelMap[facility]"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Description"
          prop="description"
          :rules="[
          { required: true, message: 'Please input Note description', trigger: 'blur' }
          ]"
        >
          <el-input :rows="3" type="textarea" v-model="note.description" required clearable/>
        </el-form-item>
        <el-form-item>
          <Uploader
            :warn="showWarning"
            :list="uploads"
            :upload-prefix="`customer/${id}/`"
            @upload-completed="addNoteDocument"
            @remove-upload="removeNoteDocument"
          />
        </el-form-item>
        <el-row>
          <el-col :offset="6" :span="6">
            <el-button @click="switchDrawer" size="small">Cancel</el-button>
          </el-col>
          <el-col :span="6">
            <el-button :loading="loading" type="primary" @click="modifyNote" size="small">Confirm</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :title="note.title"
      :visible.sync="openNote"
      width="40%">
      <Note :note="selectedNote" />
    </el-dialog>

    <el-dialog
      title="Attachments"
      :visible.sync="attachmentsDialogVisible"
      width="40%">
      <div v-if="attachmentOptions.length">
        <el-select v-model="selectedAttachmentUrl" placeholder="Select attachment" style="width: 100%">
          <el-option
            v-for="item in attachmentOptions"
            :key="item.url"
            :label="item.label"
            :value="item.url"
          ></el-option>
        </el-select>
        <div style="margin-top: 12px;">
          <el-link v-if="selectedAttachmentUrl" :href="selectedAttachmentUrl" target="_blank" type="primary">
            Open Attachment
          </el-link>
        </div>
      </div>
      <div v-else>No attachments.</div>
    </el-dialog>

    <el-dialog
      title="Edit Banner note"
      :visible.sync="bannerNoteDialogVisible"
      destroy-on-close
    >
      <template>
          <el-input style="margin-bottom: 2rem;" v-model="bannerNote"></el-input>
          <el-button @click="() => bannerNote = ''">Clear</el-button>
          <el-button :loading="dialogConfirmLoading" type="primary" @click="updateBannerNote">Save</el-button>
      </template>
    </el-dialog>

    <el-dialog title="Profile Changes" :visible.sync="profileChangesDialog" >
      <ProfileChanges :note="selectedNote" v-if="selectedNote.type === 'Profile Changes'" />
    </el-dialog>
  </el-card>
</template>

<script>
import Uploader from './Uploader.vue';
import ProfileChanges from './ProfileChanges.vue';
import Note from './Note.vue';
import Description from './Description.vue';
import axios from 'axios';
import { ADMIN_API_BASE, CUSTOMER_API_BASE } from '../env';
import { keyLabelMap, createCustomerNote, editCustomerNote, deleteCustomerNote, getCustomerNotes } from '../api/notes';

export default {
  name: 'Notes',
  props: {
    customer: { type: Object, required: true },
    id: { type: String, required: true },
    showType: { type: Boolean, default: true },
  },
  components: { Uploader, Note, Description, ProfileChanges },
  data() {
    return {
      facilities: [],
      facilityLabelMap: {},
      keyLabelMap,
      drawer: false,
      profileChangesDialog: false,
      bannerNoteDialogVisible: false,
      dialogConfirmLoading: false,
      openNote: false,
      attachmentsDialogVisible: false,
      attachmentOptions: [],
      selectedAttachmentUrl: '',
      noteType: 'all',
      facilityType: 'all',
      bannerNote: '',
      loading: false,
      processing: false,
      notes: [],
      selectedNote: {}, // Used only for viewing
      activeName: '',
      note: { // Used for storing note when editing it
        overall: false,
        type: 'General',
        description: '',
      },
    };
  },
  watch: {
    customer() {
      this.bannerNote = this.customer.bannerNote;
    },
    async id() {
      this.loading = true;
      await this.fetchNotes();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.fetchNotes();
    await this.fetchFacilityLabels();
    this.bannerNote = this.customer.bannerNote;
    this.loading = false;
  },
  computed: {
    filteredNotes() {
      let notes = this.notes;

      if (this.noteType === 'Profile Changes') { notes = this.notes.filter(note => note.type === 'Profile Changes' || note.type === 'Profile Change'); }
      else if (this.noteType !== 'all') { notes = this.notes.filter(note => note.type === this.noteType); }

      if (this.facilityType === 'overall') { notes = this.notes.filter(note => note.overall === true); }
      else if (this.facilityType !== 'all') { notes = this.notes.filter(note => note.facility === this.facilityType); }

      return notes;
    },
    uploads() {
      return this.note.attachment && this.note.attachment.url ?
        [{ url: this.note.attachment.url, name: this.note.attachment.url }] : [];
    },
    showWarning() {
      if (this.note._id) return true;
      return false;
    },
  },
  methods: {
    handleFacilityChange(facility) {
      console.log(facility);
      if (facility === 'overall') {
        this.note.overall = true;
      }
    },
    async fetchFacilityLabels() {
      const facilities = await axios.get(
        `${ADMIN_API_BASE}/facilities/`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: { limit: 55 }
        },
      );
      for (const facility of facilities.data) {
        this.facilityLabelMap[facility._id] = facility.title;
      }
    },
    async updateBannerNote() {
      this.dialogConfirmLoading = true;

      try {
        await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.id}`, {
          bannerNote: this.bannerNote,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.dialogConfirmLoading = false;

        this.$message.success({
          title: 'Success',
          message: 'Banner note updated successfully!',
        });

        this.$emit('note', this.bannerNote);
      } catch (error) {
        this.dialogConfirmLoading = false;
        this.bannerNote = this.customer.bannerNote;

        this.$message.error({
          title: 'Error',
          message: 'There was an error updating the banner note.',
        });
      }

      this.bannerNoteDialogVisible = false;
    },
    async fetchNotes() {
      const response = await getCustomerNotes(this.id, this.$keycloak.token);
      this.notes = response.data;
    },
    noteLabel(description) {
      return this.keyLabelMap[Object.keys(JSON.parse(description))[0]];
    },
    switchDrawer() {
      this.drawer = !this.drawer;
    },
    modifyNote() {
      this.$refs.note.validate(async (valid) => {
        if (valid) {
          this.switchDrawer();
          if (this.processing) return;

          const action = this.note._id ? 'edit' : 'add';
          if (this.note.overall) {
            this.note.facility = null;
          }
          try {
            this.processing = true;
            if (action === 'add') {
              await createCustomerNote(this.id, this.note, this.$keycloak.token);
              if (!this.notes) {
                this.notes = [];
              }
            } else {
              await editCustomerNote(this.id, this.note._id, this.note, this.$keycloak.token);
            }

            await this.fetchNotes();

            this.$notify.success({
              title: 'Success.',
              message: `Note ${action}ed successfully!`,
            });
          } catch (err) {
            this.$notify.error({
              title: 'Error',
              message: `There was an error while ${action}ing the note.`,
            });
            await this.fetchNotes();
          } finally {
            this.processing = false;
            this.note = {};
          }
        }
      });
    },
    openEditNote(scope) {
      this.note = scope.row;
      this.drawer = true;
    },
    viewNote(scope) {
      this.selectedNote = scope.row;

      switch (scope.row.type) {
        case 'Profile Changes': this.profileChangesDialog = true; return;
        default: this.openNote = true;
      }
    },
    normalizeAttachments(attachments) {
      if (!Array.isArray(attachments)) return [];
      return attachments
        .map((item) => {
          if (typeof item === 'string') {
            return { url: item, label: this.getAttachmentFileName(item) };
          }
          if (item && item.url) {
            return { url: item.url, label: item.name || this.getAttachmentFileName(item.url) };
          }
          return null;
        })
        .filter(Boolean);
    },
    getAttachmentFileName(url) {
      if (!url) return '';
      const [path] = url.split('?');
      const parts = path.split('/');
      return parts[parts.length - 1] || url;
    },
    openAttachments(scope) {
      const items = this.normalizeAttachments(scope.row.attachments);
      this.attachmentOptions = items;
      this.selectedAttachmentUrl = items[0] ? items[0].url : '';
      this.attachmentsDialogVisible = true;
    },
    async deleteNote(scope) {
      this.note = scope.row;
      if (this.processing) return;

      this.loading = true;
      try {
        this.processing = true;
        await deleteCustomerNote(this.id, this.note._id, this.$keycloak.token);
        this.loading = false;
        this.processing = false;

        this.$notify.info({
          title: 'Info',
          message: 'Note has been deleted.',
        });
      } catch (err) {
        this.loading = false;
        this.processing = false;
        this.$notify.error({
          title: 'Error',
          message: 'There was an error while deleting the note.',
        });
      } finally {
        await this.fetchNotes();
      }
    },
    addNoteDocument(url) {
      this.note.attachment = { url };
    },
    removeNoteDocument(url) {
      this.note.attachment = null;
    },
  },
};
</script>

<style scoped>
.control-bar {
  justify-content: space-between;
  display: flex;
  gap: 0 1rem;
  padding: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Notes.vue